<template>
  <div>
    <div v-for="(questionRep, index) in listeQuestionsReponses" :key="questionRep['id']">
      <div class="d-flex flex-column">
        <!-- TODO: Ajouter les icones aux questions -->
        <ZoneEscamotable :content="getContentZoneEscamotable(questionRep)" />
        <Separateur v-if="index !== listeQuestionsReponses.length - 1" class="w-100"></Separateur>
      </div>
    </div>
  </div>
</template>

<script>
import ZoneEscamotable from '@/components/base/ZoneEscamotable';
import Separateur from '@/components/base/Separateur';
import aide from '@/services/api/compte/aide';
import services from '@/services/index';

export default {
  name: 'Faq',
  components: {
    Separateur,
    ZoneEscamotable,
  },
  data() {
    return {
      listeQuestionsReponses: [],
    };
  },
  created() {
    this.getListQuestionsReponses();
  },
  methods: {
    async getListQuestionsReponses() {
      this.listeQuestionsReponses = await aide.getQuestionsReponses(null);
    },
    getContentZoneEscamotable(questionRep) {
      return {
        titre: questionRep.question,
        texte: questionRep.reponse,
        isOuvert: this.isActif(questionRep.id) || questionRep.isOuvert,
        name: questionRep.name,
      };
    },
    isActif(idQuestion) {
      return idQuestion !== undefined && this.idQuestion === idQuestion;
    },
  },
};
</script>
